<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <v-row dense>
      <v-col cols="12" v-if="inscripcionesPorSedes.length == 0 || inscripcionesPorAsesores.length == 0">
        <p class="text-center">No hay datos disponibles para mostrar los gráficos.</p>
      </v-col>

      <template v-else>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <canvas id="grafico-inscripciones"></canvas>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-text>
              <canvas id="grafico-inscripciones-programas"></canvas>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-text>
              <canvas id="grafico-inscripciones-asesores"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import Chart from 'chart.js';
import { obtenerColores } from '../../utils/funciones';

export default {
  name: 'GraficosInscripcionesCompletas',
  props: {
    cargando: {
      type: Boolean,
      required: true,
    },
    inscripcionesPorSedes: {
      type: Array,
      required: true,
    },
    inscripcionesPorAsesores: {
      type: Array,
      required: true,
    },
    rangoFechas: {
      type: Array,
      required: true,
    },
  },
  computed: {
    rangoFechasTexto() {
      if (this.rangoFechas.length === 2) {
        return ` (${this.rangoFechas[0]} - ${this.rangoFechas[1]})`;
      }

      return '';
    },
  },
  data() {
    return {
      graficoInscripcionesPorSedes: null,
      graficoInscripcionesPorProgramas: null,
      graficoInscripcionesPorAsesores: null,
    };
  },
  methods: {
    crearGraficos() {
      this.crearGraficoPorSedes();
      this.crearGraficoPorProgramas();
      this.crearGraficoPorAsesores();
    },
    crearGraficoPorSedes() {
      if (this.graficoInscripcionesPorSedes) {
        this.graficoInscripcionesPorSedes.destroy();
      }

      const $canvas = document.querySelector('#grafico-inscripciones');

      if (this.inscripcionesPorSedes.length === 0 || !$canvas) {
        return;
      }

      const ctx = $canvas.getContext('2d');
      const colores = obtenerColores(this.inscripcionesPorSedes.length, 0.2);
      const opciones = {
        type: 'bar',
        data: {
          labels: [...this.inscripcionesPorSedes.map((inscripcion) => inscripcion.nombre)],
          datasets: [
            {
              label: `Inscripciones por Sedes${this.rangoFechasTexto}`,
              data: [
                ...this.inscripcionesPorSedes.map((inscripcion) => inscripcion.totalInscripcionesCumplenRequisitos),
              ],
              backgroundColor: [...colores.map((color) => color.fondo)],
              borderColor: [...colores.map((color) => color.borde)],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };

      this.graficoInscripcionesPorSedes = new Chart(ctx, opciones);
    },
    crearGraficoPorProgramas() {
      if (this.graficoInscripcionesPorProgramas) {
        this.graficoInscripcionesPorProgramas.destroy();
      }

      const $canvas = document.querySelector('#grafico-inscripciones-programas');

      if (this.inscripcionesPorSedes.length === 0 || !$canvas) {
        return;
      }

      const ctx = $canvas.getContext('2d');
      const colores = obtenerColores(this.inscripcionesPorSedes.flatMap((sede) => sede.programas).length, 0.2);
      const opciones = {
        type: 'bar',
        data: {
          labels: [...this.inscripcionesPorSedes.flatMap((sede) => sede.programas.map((programa) => programa.nombre))],
          datasets: [
            {
              label: `Inscripciones por Programas${this.rangoFechasTexto}`,
              data: [
                ...this.inscripcionesPorSedes.flatMap((sede) =>
                  sede.programas.map((programa) => programa.totalInscripcionesCumplenRequisitos),
                ),
              ],
              backgroundColor: [...colores.map((color) => color.fondo)],
              borderColor: [...colores.map((color) => color.borde)],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };

      this.graficoInscripcionesPorProgramas = new Chart(ctx, opciones);
    },
    crearGraficoPorAsesores() {
      if (this.graficoInscripcionesPorAsesores) {
        this.graficoInscripcionesPorAsesores.destroy();
      }

      const $canvas = document.querySelector('#grafico-inscripciones-asesores');

      if (!$canvas) {
        return;
      }

      const ctx = $canvas.getContext('2d');
      const colores = obtenerColores(this.inscripcionesPorAsesores.length, 0.2);
      const opciones = {
        type: 'bar',
        data: {
          labels: [...this.inscripcionesPorAsesores.map((inscripcion) => inscripcion.nombreCompletoAsesor)],
          datasets: [
            {
              label: `Inscripciones por Asesores${this.rangoFechasTexto}`,
              data: [
                ...this.inscripcionesPorAsesores.map((inscripcion) => inscripcion.totalInscripcionesCumplenRequisitos),
              ],
              backgroundColor: [...colores.map((color) => color.fondo)],
              borderColor: [...colores.map((color) => color.borde)],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };

      this.graficoInscripcionesPorAsesores = new Chart(ctx, opciones);
    },
  },
};
</script>

<style>
</style>